import React from 'react';

const CarIcon = ({ svgRef, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 98 45" width="1em" height="1em" fill="currentColor" ref={svgRef} {...props}>
    <defs>
      <path
        id="a"
        d="M1023.1 52.23h-8.83v-4.04h8.83c.7 0 1.36-.3 1.8-.83.42-.5.6-1.14.5-1.79l-.67-3.87a10.07 10.07 0 0 0-8.7-8.2l-5.84-1.2a19.3 19.3 0 0 1-6.74-2.77l-9.62-6.3a20.11 20.11 0 0 0-11.06-3.3h-16.4c-2.72 0-5.41.89-7.59 2.49L953.93 26a19.8 19.8 0 0 1-7.9 3.47l-7.4 1.46a2.43 2.43 0 0 0-2 2.35V44.4c0 2.09 1.75 3.79 3.9 3.79h4.18v4.04h-4.18a7.89 7.89 0 0 1-7.93-7.83V33.28c0-3.05 2.2-5.71 5.24-6.3l7.4-1.46c2.27-.44 4.45-1.4 6.3-2.76l4.85-3.59c2.86-2.1 6.4-3.27 9.97-3.27h16.4c4.75 0 9.34 1.37 13.28 3.95l9.62 6.3a15.26 15.26 0 0 0 5.33 2.2l5.68 1.17c6 .73 11.02 5.47 12.04 11.5l.66 3.87a6.34 6.34 0 0 1-6.27 7.33z"
      />
      <path id="b" d="M950.76 44.15a6.06 6.06 0 1 0 .02 12.13 6.06 6.06 0 0 0-.02-12.13zm0 16.15a10.1 10.1 0 0 1 0-20.18 10.1 10.1 0 0 1 0 20.18z" />
      <path id="c" d="M1007.26 44.15a6.06 6.06 0 1 0 .02 12.13 6.06 6.06 0 0 0-.02-12.13zm0 16.15a10.1 10.1 0 0 1 0-20.18 10.1 10.1 0 0 1 0 20.18z" />
      <path id="d" d="M959.47 52.23v-4.04h40.92v4.04z" />
    </defs>
    <use xlinkHref="#a" transform="translate(-932 -16)" />
    <use xlinkHref="#b" transform="translate(-932 -16)" />
    <use xlinkHref="#c" transform="translate(-932 -16)" />
    <use xlinkHref="#d" transform="translate(-932 -16)" />
  </svg>
);

export default CarIcon;
